import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			path: '/policy',
			name: 'policy',
			component: (resolve) => require(['@/views/Policy.vue'], resolve),
		},
		{
			path: '/terms',
			name: 'terms',
			component: (resolve) => require(['@/views/Terms.vue'], resolve),
		},
		
	],
})
